import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

//
const login = () => import('@/page/login/login')
export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },{
        path: '/updCustomPwd',
        name: 'updCustomPwd',
        meta:{"title":"修改密码",index:'4'},
        component: () => import('@/page/user/updCustomPwd')
      },{
      path: '/layout',
      name: 'layout',
      component: () => import('@/page/layout'),
      // 嵌套路由
      children:[{
        path: '/',
        name: 'home',
        meta:{"title":"首页",index:'-1'},
        component: () => import('@/page/home/home')
      },{
        path: '/home',
        name: 'home',
        meta:{"title":"首页",index:'-1'},
        component: () => import('@/page/home/home')
      },{
        path: '/user',
        name: 'user',
        meta:{"title":"系统管理,用户管理",index:'4'},
        component: () => import('@/page/user/user')
      },{
        path: '/role',
        name: 'role',
        meta:{"title":"系统管理,角色管理",index:'5'},
        component: () => import('@/page/role/role')
      },{
        path: '/depart',
        name: 'depart',
        meta:{"title":"系统管理,部门管理",index:'6'},
        component: () => import('@/page/depart/depart')
      },{
        path: '/order',
        name: 'order',
        meta:{"title":"订单管理,订单管理",index:'7'},
        component: () => import('@/page/order/order'),
        children:[]
      },{
        path: '/orderDict',
        name: 'orderDict',
        meta:{"title":"订单管理,字典管理",index:'13'},
        component: () => import('@/page/ordernew/dict'),
      },{
        path: '/orderNew',
        name: 'orderNew',
        meta:{"title":"订单管理,新订单管理",index:'14'},
        component: () => import('@/page/ordernew/order-new'),
      },{
        path: '/order/addOrderNew',
        name: 'addOrderNew',
        meta:{"title":"订单管理,新订单管理,新增订单",index:'14'},
        component: () => import('@/page/ordernew/addOrder-new')
      },{
        path: '/order/updateOrderNew/:orderId',
        name: 'addOrderNew',
        meta:{"title":"订单管理,新订单管理,修改订单",index:'14'},
        component: () => import('@/page/ordernew/updateOrder-new')
      },{
        path: '/customOrder',
        name: 'customOrder',
        meta:{"title":"订单管理,创建订单",index:'14'},
        component: () => import('@/page/wbOrder/creatOrder')
      },{
        path: '/approvalOrder',
        name: 'approvalOrder',
        meta:{"title":"订单管理,订单审批",index:'14'},
        component: () => import('@/page/ordernew/approvalOrder'),
      },{
        path: '/order/detailOrderNew/:orderId',
        name: 'addOrderNew',
        meta:{"title":"订单管理,新订单管理,订单详情",index:'14'},
        component: () => import('@/page/ordernew/detailOrder-new')
      },{
        path: '/order/detailOrderNew/:orderId',
        name: 'addOrderNew',
        meta:{"title":"订单管理,新订单管理,订单详情",index:'14'},
        component: () => import('@/page/ordernew/detailOrder-new')
      },{
        path: '/order/addOrder',
        name: 'addOrder',
        meta:{"title":"订单管理,订单管理,新增订单",index:'7'},
        component: () => import('@/page/order/addOrder')
      },{
        path: '/updateOrder/:oId',
        name: 'updateOrder',
        meta:{"title":"订单管理,订单管理,修改订单",index:'7'},
        component: () => import('@/page/order/updateOrder')
      },{
        path: '/detailOrder/:oId',
        name: 'detailOrder',
        meta:{"title":"订单管理,订单管理,订单详情",index:'7'},
        component: () => import('@/page/order/detailOrder')
      },{
        path: '/report',
        name: 'report',
        meta:{"title":"报表管理,报表",index:'12'},
        component: () => import('@/page/report/reportList')
      },{
        path: '/reportCloth',
        name: 'reportCloth',
        meta:{"title":"报表管理,衣服统计",index:'15'},
        component: () => import('@/page/report/reportForCloth')
      },{
        path: '/reportKz',
        name: 'reportKz',
        meta:{"title":"报表管理,裤子统计",index:'17'},
        component: () => import('@/page/report/reportForKz')
      },{
        path: '/reportMj',
        name: 'reportMj',
        meta:{"title":"报表管理,马甲统计",index:'16'},
        component: () => import('@/page/report/reportForMj')
      },{
        path: '/reportSkirt',
        name: 'reportSkirt',
        meta:{"title":"报表管理,裙子统计",index:'18'},
        component: () => import('@/page/report/reportForSkirt')
      },{
        path: '/updUserPwd',
        name: 'updUserPwd',
        meta:{"title":"修改密码",index:'4'},
        component: () => import('@/page/user/updUserPwd')
      },{
        path: '/dataBase',
        name: 'dataBase',
        meta:{"title":"备份管理,数据备份",index:'13'},
        component: () => import('@/page/dataBase/dataList')
      }]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js